import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {MatButton} from "@angular/material/button";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {RecordData} from "../../../../types/records-table.types";
import {bloggerModalResourceType} from "../configs/blogger-modal-config";
import {ConfirmDeduplicationProps} from "../types/confirm-deduplication-modal.types";
import {BloggerModalService} from "../services/blogger-modal.service";
import {confirmDeduplicationModalName} from "../configs/confirm-deduplication-config";
import {BloggerInfoComponent} from "../components/blogger-info/blogger-info.component";

@Component({
  selector: 'app-confirm-deduplication-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatButton,
    BloggerInfoComponent
  ],
  templateUrl: './confirm-deduplication-modal.component.html',
  styleUrl: './confirm-deduplication-modal.component.scss'
})
export class ConfirmDeduplicationModalComponent extends BaseModalComponent {
  public dialogData = inject<ConfirmDeduplicationProps>(MAT_DIALOG_DATA);
  private bloggerModalService: BloggerModalService = inject(BloggerModalService);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(confirmDeduplicationModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(confirmDeduplicationModalName);
  }

  public async handleConfirm(): Promise<void> {
    const bloggerDeduplicationProps = {
      currentBloggerId: Number(this.dialogData.originBlogger.id),
      duplicateBloggerId: Number(this.dialogData.duplicateBlogger.id)
    };

    await this.bloggerModalService.bloggerDeduplication(bloggerDeduplicationProps)
      .then(() => this.closeDialog('success'))
      .catch(() => this.closeDialog('cancel'));
  }

  public handleOpenBloggerModal(bloggerData: RecordData) {
    this.modalsService.getStatusFromBloggerCardModal({
      columnParamKey: 'blogger',
      columnParam: this.dialogData.tableColumnParams!,
      recordData: bloggerData,
      path: bloggerModalResourceType.path
    });
  }
}
